// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__3gwB2","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__1GP1q"};